export default __webpack_public_path__ + "static/media/birthday.1e40c150.svg";